(function () {
  'use strict';
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () {
    var io = ('IntersectionObserver' in window)
      ? new IntersectionObserver(function (entries) { entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('pv-in'); io.unobserve(e.target); } }); }, { threshold: 0.08 })
      : null;
    document.querySelectorAll('.pv-reveal').forEach(function (el) { if (io) io.observe(el); else el.classList.add('pv-in'); });
    (function () {
      var top = document.querySelector('nav.pv-trust-top');
      if (!top) return;
      var html = top.innerHTML;
      document.querySelectorAll('[data-pv-trust-clone]').forEach(function (c) { c.innerHTML = html; });
    })();
  });
})();
